import { useEffect, useState } from "react";
import { getUtilisateurs } from "../lib/utilisateur";
import { useAuth } from "../context/AuthContext.js";

/**
 * Charge la liste de tous les utilisateurs au montage et expose `{ users, createUserList, loading, error }`.
 *
 * @returns {{ users: Array, createUserList: Function, loading: boolean, error: string|null }}
 */
export function useGetUsers() {
  const [users, setUsers] = useState([]);  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isConnected } = useAuth();
  

  const createUserList = async () => {
    try {
      setLoading(true);
      setError(null);
      const userList = await getUtilisateurs();
      setUsers(userList);
    } catch (err) {
      setError("Erreur lors de la récuperation des utilisateurs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isConnected) createUserList();
  }, []);

  return { users, createUserList, loading, error };
}
